
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import WizardFlow from './wizard/WizardFlow';

export default function Contact() {
  const { t } = useTranslation();
  const highlights = [
    { icon: 'ri-brain-line', text: t('homeSections.contact.highlights.profile') },
    { icon: 'ri-map-2-line', text: t('homeSections.contact.highlights.itinerary') },
    { icon: 'ri-time-line', text: t('homeSections.contact.highlights.speed') },
    { icon: 'ri-shield-check-line', text: t('homeSections.contact.highlights.security') },
  ];

  return (
    <section
      id="contact"
      className="py-28 px-6 bg-gradient-to-b from-[#0A1628] to-[#0F1F38] relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#C9A84C]/5 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-[#C9A84C]/10 blur-3xl pointer-events-none"></div>

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Bloco Introdutório */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#C9A84C]/40 bg-[#C9A84C]/10 mb-8">
            <i className="ri-sparkling-2-line text-[#C9A84C]"></i>
            <span className="text-[#C9A84C] text-xs font-bold uppercase tracking-widest">
              {t('homeSections.contact.badge')}
            </span>
          </div>

          <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-5 leading-tight">
            {t('homeSections.contact.titleLine1')}
            <br />
            <span className="text-[#C9A84C]">{t('homeSections.contact.titleLine2')}</span>
          </h2>

          <div className="w-20 h-0.5 bg-[#C9A84C] mx-auto mb-7"></div>

          <p className="text-white/90 text-lg max-w-2xl mx-auto leading-relaxed">
            {t('homeSections.contact.description')}
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-sm text-white">
            {highlights.map((item, i, arr) => (
              <Fragment key={i}>
                <div className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-[#C9A84C]`}></i>
                  </div>
                  <span className="text-white font-medium drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)]">
                    {item.text}
                  </span>
                </div>
                {i < arr.length - 1 && <div className="w-px h-4 bg-white/30"></div>}
              </Fragment>
            ))}
          </div>
        </div>

        {/* Wizard de 10 etapas */}
        <WizardFlow />

        {/* WhatsApp QR Code */}
        <div className="mt-16 flex flex-col items-center">
          <div className="bg-white/5 backdrop-blur-sm border border-[#C9A84C]/30 rounded-3xl p-8 flex flex-col md:flex-row items-center gap-8 max-w-2xl w-full shadow-xl">
            <div className="flex flex-col items-center gap-3">
              <div className="w-44 h-44 rounded-2xl overflow-hidden border-4 border-[#C9A84C]/40 shadow-lg bg-white flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/adb35acbf43dddb6c47392f03bc1d026/8589abc7fb9a5da979c9d586e42c6910.jpeg"
                  alt="QR Code WhatsApp Aero Destiny Travel"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-white/80 text-xs tracking-widest uppercase">
                {t('homeSections.contact.qrHint')}
              </span>
            </div>
            <div className="flex flex-col items-center md:items-start gap-4 text-center md:text-left">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-green-500/20">
                  <i className="ri-whatsapp-line text-green-400 text-xl"></i>
                </div>
                <span className="text-white font-bold text-lg">{t('homeSections.contact.directTitle')}</span>
              </div>
              <p className="text-white/80 text-sm leading-relaxed">
                {t('homeSections.contact.directDescription')}
              </p>
              <p className="text-[#C9A84C] font-semibold text-sm">wa.me/5562995436807</p>
              <a
                href="https://wa.me/5562995436807"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-green-500 hover:bg-green-400 text-white font-bold rounded-xl transition-all duration-300 shadow-lg hover:shadow-green-500/30 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                {t('homeSections.contact.whatsappCta')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
